import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useIsAdmin } from '../hooks/useIsAdmin';

interface AdminProtectedRouteProps {
  children: React.ReactNode;
}

const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, userEmail } = useAuth();
  const { isAdmin, loading: isAdminLoading } = useIsAdmin();
  const location = useLocation();
  
  // For debugging
  console.log('AdminProtectedRoute - isAuthenticated:', isAuthenticated);
  console.log('AdminProtectedRoute - isAdmin:', isAdmin);
  console.log('AdminProtectedRoute - userEmail:', userEmail);
  console.log('AdminProtectedRoute - location:', location.pathname);

  // Show loading state
  if (isLoading || isAdminLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-gray-600">Loading...</div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    console.log('AdminProtectedRoute - Not authenticated, redirecting to login');
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Redirect to dashboard if not an admin
  if (!isAdmin) {
    console.log('AdminProtectedRoute - Not admin, redirecting to dashboard');
    return <Navigate to="/dashboard" replace />;
  }

  // Render children when authenticated and is admin
  console.log('AdminProtectedRoute - Rendering admin content');
  return <>{children}</>;
};

export default AdminProtectedRoute;
